export const Label = ({ title = "" }) => (
  <div className="text-blue-600 text-sm font-semibold pt-5 pb-4 w-full">
    {title}
  </div>
);
